module.exports = __webpack_public_path__ + "static/media/fundo.8a30658d.jpg";